module.exports = __webpack_public_path__ + "images/category_lp/watch/reason2@2x_6b05b176dc511ed18c4408a77e31ba11.png";